module.exports = __webpack_public_path__ + "static/img/bg.21c5a97d.png";